import { render } from "./ExamWorkPage.vue?vue&type=template&id=57c1b888&scoped=true"
import script from "./ExamWorkPage.vue?vue&type=script&lang=js"
export * from "./ExamWorkPage.vue?vue&type=script&lang=js"

import "./ExamWorkPage.vue?vue&type=style&index=0&id=57c1b888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c1b888"]])

export default __exports__